import { _ as __wbg_init, ab as _exports, a3 as initSync$1 } from './index.js';

const module$1 = new URL("aleo_wasm.wasm", import.meta.url);

                async function init(options) {
                    await __wbg_init({
                        module_or_path: await options.module,
                        memory: options.memory,
                    });
                    return _exports;
                }

                function initSync(options) {
                    initSync$1({
                        module: options.module,
                        memory: options.memory,
                    });
                    return _exports;
                }

export { init, initSync, module$1 as module };
//# sourceMappingURL=aleo_wasm_custom.js.map
